/** Presentation-facing events emitted by world-sim (rules stay pure aside from this queue). */

export const FfaEvent = {
  Attack: "attack",
  Hit: "hit",
  Death: "death",
  Summon: "summon",
  ManaCollect: "mana_collect",
  MasterDrop: "master_drop",
  GoalSet: "goal_set",
} as const;

export type FfaEventKind = (typeof FfaEvent)[keyof typeof FfaEvent];

export type SimEvent =
  | {
      kind: typeof FfaEvent.Attack;
      time: number;
      attackerId: number;
      targetId: number;
      teamId: number;
      x0: number;
      y0: number;
      x1: number;
      y1: number;
      role: string;
      style: string;
      ranged: boolean;
    }
  | {
      kind: typeof FfaEvent.Hit;
      time: number;
      attackerId: number;
      targetId: number;
      teamId: number;
      x: number;
      y: number;
      damage: number;
      hp: number;
      maxHp: number;
      targetRole: string;
      attackerRole: string;
      mode: string;
    }
  | {
      kind: typeof FfaEvent.Death;
      time: number;
      entityId: number;
      x: number;
      y: number;
      role: string;
      teamId: number;
      isMaster: boolean;
    }
  | {
      kind: typeof FfaEvent.Summon;
      time: number;
      entityId: number;
      teamId: number;
      x: number;
      y: number;
      role: string;
    }
  | {
      kind: typeof FfaEvent.ManaCollect;
      time: number;
      teamId: number;
      x: number;
      y: number;
      value: number;
      jackpot: boolean;
    }
  | {
      kind: typeof FfaEvent.MasterDrop;
      time: number;
      x: number;
      y: number;
      value: number;
      teamId: number;
    }
  | {
      kind: typeof FfaEvent.GoalSet;
      time: number;
      teamId: number;
      x: number;
      y: number;
    };

export function drainEvents(eventsOut: SimEvent[]): SimEvent[] {
  if (eventsOut.length === 0) return [];
  const copy = eventsOut.slice();
  eventsOut.length = 0;
  return copy;
}
